import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  selectedAnimalLotModalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,

    width: '100%',
    overflowY: 'auto'
  },

  inputContainer: {
    width: '100%',
    paddingBottom: 8,
    borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
  },

  animalCard: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    padding: 16,
    borderRadius: theme.app.borderRadius.md,
    backgroundColor: theme.app.colors.input.background
  },

  animalInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,

    '& span:first-child': {
      fontWeight: 500,
      color: theme.palette.primary.main,
      fontSize: theme.app.typography.body.fontSize
    },

    '& span:last-child': {
      fontWeight: 500,
      color: '#000',
      fontSize: theme.app.typography.label.fontSize
    }
  },
  noAnimalFound: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 250,

    '& span': {
      fontWeight: 600,
      color: alpha(theme.palette.primary.main, 0.7),
      fontSize: theme.app.typography.h3.fontSize
    }
  }
}))
